module.exports = __webpack_public_path__ + "img/close-danger.0df39bd5.svg";